import { CheckCircle, Sparkle } from "@phosphor-icons/react";

export function VerifiedBadge({ size = "sm" }) {
    return (
        <span className="badge-verified" data-testid="verified-badge">
            <CheckCircle weight="fill" size={size === "sm" ? 12 : 14} />
            Documentación revisada
        </span>
    );
}

export function ExportBadge() {
    return (
        <span className="badge-export" data-testid="export-badge">
            <Sparkle weight="fill" size={12} />
            Exportación
        </span>
    );
}
